export const GPIO_MAPPING = [
  { index: 0, name: 'RST', connector: 'Target.10' },
  { index: 1, name: 'TDI', connector: 'Target.8' },
  { index: 2, name: 'TDO', connector: 'Target.6' },
  { index: 3, name: 'SWDCK', connector: 'Target.4' },
  { index: 4, name: 'SWDIO', connector: 'Target.2' },
  { index: 5, name: 'SCL_FACTORYRST', connector: '' },
  { index: 6, name: 'EXT_A2', connector: 'PA1.2' },
  { index: 7, name: 'EXT_A3', connector: 'PA1.3' },
  { index: 8, name: 'EXT_A4', connector: 'PA1.4' },
  { index: 9, name: 'EXT_A5', connector: 'PA1.5' },
  { index: 10, name: 'EXT_A6', connector: 'PA1.6' },
  { index: 11, name: 'EXT_A7', connector: 'PA1.7' },
  { index: 12, name: 'EXT_A8', connector: 'PA1.8' },
  { index: 13, name: 'EXT_A9', connector: 'PA1.9' },
  { index: 14, name: 'EXT_A10', connector: 'PA1.10' },
  { index: 15, name: 'EXT_A11', connector: 'PA1.11' },
  { index: 16, name: 'EXT_B2', connector: 'PA2.2' },
  { index: 17, name: 'EXT_B3', connector: 'PA2.3' },
  { index: 18, name: 'EXT_B4', connector: 'PA2.4' },
  { index: 19, name: 'EXT_B5', connector: 'PA2.5' },
  { index: 20, name: 'EXT_B6', connector: 'PA2.6' },
  { index: 21, name: 'EXT_B7', connector: 'PA2.7' },
  { index: 22, name: 'EXT_B8', connector: 'PA2.8' },
  { index: 23, name: 'EXT_B9', connector: 'PA2.9' },
  { index: 24, name: 'EXT_B10', connector: 'PA2.10' },
  { index: 25, name: 'EXT_B11', connector: 'PA2.11' },
];
